import { Image, Text, VStack } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import logo from 'assets/logo-b2b-nav.svg';
import { ROUTES } from 'router/routes';
import { LINK } from './footerStyles';
import { SocialRow } from './FooterSocials';

export const BrandBlock = () => (
  <VStack align='flex-start' spacing={5} maxW='320px'>
    <Link to={ROUTES.home} aria-label='Ticket Zone home'>
      <Image src={logo} w='140px' h='auto' alt='ticket zone logo' objectFit='contain' />
    </Link>
    <Text color={LINK} textAlign='start' fontSize='sm' lineHeight='1.75'>
      <FormattedMessage
        id='footer.tagline'
        defaultMessage="Iraq's leading platform for event ticketing."
      />
    </Text>
    <SocialRow />
  </VStack>
);
